var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColumns = function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M2.945 14.555c-1.632 0-2.453-.805-2.453-2.414V2.594c0-1.61.82-2.422 2.453-2.422h13.516c1.64 0 2.453.812 2.453 2.422v9.547c0 1.609-.812 2.414-2.453 2.414zm.016-1.258h3.25V1.43H2.96c-.781 0-1.211.422-1.211 1.234v9.406c0 .813.43 1.227 1.21 1.227m4.508 0h4.469V1.43h-4.47zM16.445 1.43h-3.25v11.867h3.25c.774 0 1.211-.414 1.211-1.227V2.664c0-.812-.437-1.234-1.21-1.234"
  })));
};
export default SvgColumns;